import { Map, APILoader } from '@uiw/react-baidu-map';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function BaiduMap({ storeLists, center, zoom, logoCard }: any) {
    return (
        <APILoader akay="hV5md76VUaZ7rxfsidjd5t55NXy5aUE2">
            <Map center={center} zoom={zoom}>
                {({ BMap, map }) => {
                    map.addControl(new BMap.NavigationControl()); // 缩放平移控件
                    map.addControl(new BMap.ScaleControl()); // 比例尺
                    map.addControl(new BMap.MapTypeControl()); // 地图类型

                    storeLists?.map((store: any) => {
                        const point = new BMap.Point(store.longitude, store.latitude);
                        const myIcon = new BMap.Icon(
                            handleDynamicPath(`/media/wheretobuy/retail/logo_${store?.virtualFlag ? 'white' : 'black'}.svg`),
                            new BMap.Size(40, 40),
                        );
                        const marker = new BMap.Marker(point, { icon: myIcon });
                        map.addOverlay(marker); // 添加标注图标

                        const info: any = new BMap.InfoWindow(renderBMapInfoWindow(store), { offset: new BMap.Size(0, 10) }); // 标注信息
                        info.enableAutoPan();
                        info.enableCloseOnClick();
                        if (storeLists?.length === 1) {
                            map.openInfoWindow(info, point);
                        }
                        if (
                            logoCard?.show &&
                            Number(logoCard?.data?.latitude) === Number(store.latitude) &&
                            Number(logoCard?.data?.longitude) === Number(store.longitude)
                        ) {
                            map.openInfoWindow(info, point);
                        }
                        marker?.addEventListener('click', function () {
                            map.openInfoWindow(info, point);
                        });
                    });
                    return;
                }}
            </Map>
        </APILoader>
    );
}

// cn站info弹窗
const renderBMapInfoWindow = (store: any) => {
    let htmlFrag = "<div class='bMapInfoWindowContent'>";
    if (store.name) {
        htmlFrag += `<div class="store_name">${store?.name}</div>`;
    }
    if (store.address && !store?.virtualFlag) {
        const dynamicSrc = handleDynamicPath('/media/wheretobuy/retail/location.svg');
        htmlFrag += `<div class="store_address common">
				<div class="icon"><img class="custome" width='20' height='20' src="${dynamicSrc}" /></div>
				<div class="text">
						${store?.address}
				</div>
		</div>`;
    }
    if (store.phone) {
        const dynamicSrc = handleDynamicPath('/media/wheretobuy/retail/phone.svg');
        htmlFrag += `<div class="store_phone common">
				<div class="icon"><img class="custome" width='20' height='20' src="${dynamicSrc}" /></div>
				<a class="text" href="tel:${store?.phone}">
						${store?.phone}
				</a>
		</div>`;
    }
    if (store.email) {
        const dynamicSrc = handleDynamicPath('/media/wheretobuy/retail/email.svg');
        htmlFrag += `<div class="store_email common">
				<div class="icon"><img class="custome" width='20' height='20' src="${dynamicSrc}" /></div>
				<a class="text" href="mailto:${store?.email}">
						${store?.email}
				</a>
		</div>`;
    }
    if (store.webLink) {
        const dynamicSrc = handleDynamicPath('/media/wheretobuy/retail/global.svg');
        htmlFrag += `<div class="store_website common">
				<div class="icon"><img class="custome" width='20' height='20' src="${dynamicSrc}" /></div>
				<a class="text" href="${store?.webLink}" target="_blank">
						${store?.webLink}
				</a>
		</div>`;
    }
    if (store.businessTime) {
        const dynamicSrc = handleDynamicPath('/media/wheretobuy/retail/clock.svg');
        htmlFrag += `<div class="store_openTime common">
				<div class="icon"><img class="custome" width='20' height='20' src="${dynamicSrc}" /></div>
				<div class="text">
						${store?.businessTime}
				</div>
		</div>`;
    }
    if (store.label && store.label?.split(';')?.length > 0) {
        htmlFrag += `<div class="store_tags">`;
        store?.label?.split(';')?.map((tag: any) => (htmlFrag += `<li class="store_tag_item">${tag}</li>`));
        htmlFrag += '</div>';
    }
    htmlFrag += '</div>';
    return htmlFrag;
};
